module.exports = __webpack_public_path__ + "img/icono_G2_ing.c0f13bad.svg";